// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderTitle":"c-j_gU"};